import { render } from "./categoria-editar.vue?vue&type=template&id=c5f2c848&scoped=true"
import script from "./categoria-editar.vue?vue&type=script&lang=js"
export * from "./categoria-editar.vue?vue&type=script&lang=js"

import "./categoria-editar.vue?vue&type=style&index=0&id=c5f2c848&scoped=true&lang=css"

import exportComponent from "/home/econopro-ubuntu/Documents/econopro/fonts/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5f2c848"]])

export default __exports__